import { render, staticRenderFns } from "./CardCandidatoLogado.vue?vue&type=template&id=208e58ee&"
import script from "./CardCandidatoLogado.vue?vue&type=script&lang=js&"
export * from "./CardCandidatoLogado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports